export default __webpack_public_path__ + "static/media/vehicle_model_illustration.ebabc067.png";